interface ModalLayoutProps {
  isDark: boolean;
  header: React.ReactNode;
  content: React.ReactNode;
  onBackdropClick: () => void;
}

export const ModalLayout: React.FC<ModalLayoutProps> = ({
  isDark,
  header,
  content,
  onBackdropClick,
}) => {
  return (
    <>
      <div
        className="fixed inset-0 z-60 backdrop-blur-xl bg-black/60 transition-all duration-300"
        onClick={onBackdropClick}
      />

      <div className="fixed inset-0 z-70 flex flex-col items-center justify-center p-2 sm:p-4 pointer-events-none">
        <div
          className="rounded-2xl shadow-3xl w-full max-w-5xl h-full sm:h-auto max-h-screen sm:max-h-[95vh] overflow-hidden pointer-events-auto animate-in fade-in zoom-in duration-300 flex flex-col border border-(--border-color)"
          style={{ backgroundColor: "var(--modal-bg)" }}
        >
          {header}

          <div
            className="flex-1 overflow-y-auto p-4 sm:p-8"
            style={{ backgroundColor: "var(--bg-secondary)" }}
          >
            <div className="max-w-4xl mx-auto">{content}</div>
          </div>
        </div>
      </div>
    </>
  );
};
